module.exports = __webpack_public_path__ + "img/level_two_hover.01201bd5.png";